interface IProps {
    size?: number;
    color?: string;
}

export const IconCheck = (props: IProps) => {
    const { size, color } = props;
    const defaultSize = "55";
    const defaultColor = "#1CC556";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 55 56"
            fill="none"
        >
            <path
                d="M27.4998 0.888885C12.604 0.888885 0.416504 13.2639 0.416504 28.3889C0.416504 43.5139 12.604 55.8889 27.4998 55.8889C42.3957 55.8889 54.5832 43.5139 54.5832 28.3889C54.5832 13.2639 42.3957 0.888885 27.4998 0.888885ZM39.1457 21.7889L26.6873 38.2889C26.1457 38.8389 25.3332 39.3889 24.5207 39.3889C23.7082 39.3889 22.8957 39.1139 22.354 38.2889L15.854 29.7639C15.0415 28.6639 15.0415 26.7389 16.3957 25.9139C17.7498 25.0889 19.3748 25.0889 20.1873 26.4639L24.5207 32.2389L34.8123 18.4889C35.6248 17.3889 37.5207 17.1139 38.604 17.9389C39.9582 18.7639 39.9582 20.4139 39.1457 21.7889Z"
                fill={color || defaultColor}
            />
        </svg>
    );
};
